import React from 'react';
import Button from '../bootstrap/Button.jsx';

function ToggleButtonGroup({
  items,
  multiple = false,
  value,
  defaultValue,
  onChange,
  size,
  disabled = false,
  className = '',
  btnStyle = {},
  containerStyle = {}
}) {
  const isControlled = value !== undefined;

  const initial = React.useMemo(() => {
    if (defaultValue !== undefined) return defaultValue;
    return multiple ? [] : null;
  }, [defaultValue, multiple]);

  const [internal, setInternal] = React.useState(initial);

  const current = isControlled ? value : internal;

  const selected = new Set(
    multiple ? current || [] : current != null ? [current] : []
  );

  const commit = (next) => {
    if (!isControlled) setInternal(next);
    if (onChange) onChange(next);
  };

  const toggle = (v) => {
    if (disabled) return;

    if (!multiple) {
      commit(v);
      return;
    }

    const next = new Set(selected);
    next.has(v) ? next.delete(v) : next.add(v);
    commit(Array.from(next));
  };

  return (
    <div className={`btn-group ${className}`} role='group'>
      {items.map(({ value: v, label, type }) => {
        const isSelected = selected.has(v);
        return (
          <Button
            key={v}
            type={isSelected ? type || 'primary' : 'default'}
            size={size}
            disabled={disabled}
            aria-pressed={isSelected}
            onClick={() => toggle(v)}
            style={btnStyle}
          >
            {label}
          </Button>
        );
      })}
    </div>
  );
}

export default ToggleButtonGroup;